require('./cart-delivery-phone-form.scss');
require('jquery-mask-plugin');
import intlTelInput from '../../../../vendor/intl-tel-input/js/intlTelInput-jquery';

var BaseViews = require('../../base');
var CartLocationDisplay = require('../cart-location-display');

var CartDeliveryPhoneForm = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-delivery-phone-form',
    template: require('./cart-delivery-phone-form.html'),
    ui: {
        alertMessage: '.fmcy-cart-delivery-phone-form-alert-message',
        alertMessageText: '.alert-danger',
        phoneInput: '#fmcy-cart-delivery-phone-field'
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                error: false,
                errorMessage: 'Please enter phone number below.'
            }
        );
    },
    modelEvents: function () {
        var self = this;
        return _.extend(
            {},
            _.result(BaseViews.LayoutView.prototype, 'modelEvents'),
            {
                validated: self.maybeDisplayValidationAlert.bind(self)
            }
        );
    },
    validatedFields: function () {
        var validatedFields = [
          'deliveryPhone'
        ];
        return validatedFields;
    },
    toggleValidationAlert: function (show) {
        if (show) {
            this.ui.alertMessage.removeClass('hidden');
        } else {
            this.ui.alertMessage.addClass('hidden');
        }
    },
    maybeDisplayValidationAlert: function () {
        if (this.$el.find('.has-error').length) {
            this.toggleValidationAlert(true);
        } else {
            this.toggleValidationAlert(false);
        }
    },
    onModelAttributeValid: function (attr, selector) {
        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
            this.maybeDisplayValidationAlert();
        }
    },
    onModelAttributeInvalid: function (attr, error, selector, hideAlertMessage) {
        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
            if (!hideAlertMessage) {
              this.maybeDisplayValidationAlert();
            }
        }
    },
    events: function () {
        var self = this;

        function setVisited (ev) {
            self._setElementAsVisited($(ev.target));
        }
        function onChange (ev) {
            self.model.set('deliveryPhone', self.getNumber());
        }
        return {
            'blur input': setVisited,
            'keyup @ui.phoneInput': onChange,
            'change @ui.phoneInput': onChange,
            'countrychange @ui.phoneInput': onChange
        };
    },
    serializeData: function () {
        return {
            errorMessage: this.options.errorMessage,
            error: this.options.error
        };
    },
    setNumber: function (number) {
        if(this.ui.phoneInput && this.ui.phoneInput.intlTelInput && number) {
            this.ui.phoneInput.intlTelInput("setNumber", number);
        }
    },
    getNumber: function () {
        if(this.ui.phoneInput && this.ui.phoneInput.intlTelInput && this.ui.phoneInput.intlTelInput("getNumber")) {
            return this.ui.phoneInput.intlTelInput("getNumber");
        } else {
            if (this.ui.phoneInput.val()) {
                var dialcode = this.ui.phoneInput.intlTelInput("getSelectedCountryData").dialCode;
                return '+' + dialcode + this.ui.phoneInput.val().replace(/[^\d]/g, '');
            } else {
                return '';
            }
        }
    },
    onRender: function () {
        var self = this;
        self.ui.phoneInput.intlTelInput({
            initialCountry: "ca",
            separateDialCode: true,
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
        });
        if (this.options.error) {
          this.ui.alertMessageText.html(this.options.errorMessage);
          this.toggleValidationAlert(true);
        }

        self.ui.phoneInput.val(this.model.get('deliveryPhone'));
        self.setNumber(this.model.get('deliveryPhone'));

        BaseViews.LayoutView.prototype.onRender.call(this);
    }
});
module.exports = CartDeliveryPhoneForm;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-delivery-address/cart-delivery-phone-form.js
 **/